import { businessCell, isIsoDateCell } from '@/frontend/features/Fde/investigations/businessCasePresentation'
import type { BusinessEvidenceView, InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

interface Props { rows: BusinessEvidenceView['rows']; columns: BusinessEvidenceView['columns']; rowIndices: number[]; copy: InvestigationLabels }

export default function EvidenceTable({ rows, columns, rowIndices, copy }: Props) {
  return <div className="min-w-0 overflow-x-auto">
    <table className="w-full text-left text-sm">
      <thead><tr className="border-b border-border">{columns.map((column) => <th key={column.field} scope="col" className="px-2 py-2 align-bottom text-xs font-medium text-muted-foreground first:pl-0 last:pr-0">{column.label}</th>)}</tr></thead>
      <tbody>{rows.map((row, index) => <tr key={`${rowIndices[index]}:${index}`} className="border-b border-border/50 last:border-0">
        {columns.map((column) => <td key={column.field} className={`min-w-20 px-2 py-2.5 align-top tabular-nums first:pl-0 last:pr-0 ${isIsoDateCell(row[column.field]) ? 'whitespace-nowrap' : 'max-w-80 break-words'}`}>
          {businessCell(row[column.field], copy.business_value_missing, copy.business_list_empty)}
        </td>)}
      </tr>)}</tbody>
    </table>
  </div>
}
